export default {
  // 新增消防台账
  insertPaFireLedger: '/ygsjzs/paFireLedger/insertPaFireLedger',
  // 修改消防台账
  updatePaFireLedger: '/ygsjzs/paFireLedger/updatePaFireLedger',
  // 删除消防台账
  deletePaFireLedger: '/ygsjzs/paFireLedger/deletePaFireLedger',
  // 查询消防台账详情
  selectPaFireLedgerByLedgerId: '/ygsjzs/paFireLedger/selectPaFireLedgerByLedgerId',
  // 分页查询消防台账列表
  selectPaFireLedgerByPage: '/ygsjzs/paFireLedger/selectPaFireLedgerByPage'

}
